import { ProvideNames } from '#shared/statics';

export default defineNuxtRouteMiddleware(async (to, from) => {
    if (import.meta.server) {
        useLogger('storeSlugHandler').debug('skip');
        return;
    }

    const storeSlug = to.params?.storeslug;
    if (storeSlug && typeof storeSlug === 'string' && storeSlug != 'online') {
        useLogger('storeSlugHandler').debug('storeSlug handler found', storeSlug);
        if (storeSlug.toLowerCase() != useCurrentStore()?.value?.storeLink?.toLowerCase()?.replace('/', '') && !ProvideNames.FINDER_SYNONYMS.includes(storeSlug?.toLowerCase())) {
            useLogger('storeSlugHandler').debug(
                'storeSlug did not match currentStore, searching for store with slug',
                storeSlug,
            );
            const storeId = await getStoreIdOrNullBySlug(storeSlug?.toLocaleLowerCase());
            useLogger('storeSlugHandler').debug('storeSlug did not match currentStore setting store to', storeId);
            if (storeId) {
                await nextTick(() => {
                    changeToStoreById(
                        storeId,
                        useCurrentStore()?.value?.id,
                        'storeslug-url',
                    );
                });
            } else if (!storeId) {
                return navigateTo('/', { redirectCode: 307 });
            }
        } else if (
            ProvideNames.FINDER_SYNONYMS.includes(storeSlug?.toLowerCase()) 
            && useCurrentStore()?.value?.storeLink?.toLowerCase()?.replace('/', '')
        ) {
            return navigateTo(
                to?.fullPath?.replace(
                    ProvideNames.FINDER_SYNONYMS.find((sl) => sl == storeSlug?.toLowerCase()) ?? '',
                    useCurrentStore()?.value?.storeLink?.toLowerCase()?.replace('/', ''),
                ),
                { redirectCode: 307 },
            );
        }
    } else {
        useLogger('storeSlugHandler').debug('storeSlug did match central, switching');
        await nextTick(() => {
            changeToStoreById(
                ProvideNames.DEFAULT_CENTRAL_STORE.id,
                useCurrentStore()?.value?.id,
                'storeslug-url',
            );
        });
    }
});
